const theme = {
  fontSizes: [12, 14, 16, 24, 32, 48, 64, 96, 128],
  space: [
    // margin and padding
    0,
    4,
    8,
    16,
    32,
    64,
    128,
    256,
  ],
  colors: {
    purple: '#621CEB',
  },

  zIndices: {
    nav: 9,
  },

  sizes: {
    nav: '100px',
  },
}

export default theme
